/**
 * Auth-aware fetch helper for the feature's TanStack Query hooks.
 *
 * Mirrors the helpers in `feature-epi-chat`, `feature-analytical-variables`,
 * and `feature-concept-groups-list`. Four copies now — escalating the
 * "promote to @verantos-dev/core-utils" follow-up across the same TODO.
 */

// TODO: cleanup with research_assistant_gen_3 ff — fold authFetch into
// @verantos-dev/core-utils once a fifth feature wants the same shape.

import { getToken } from '@verantos-dev/core-auth';
import { getBaseApiUrl, getGatewayApiVersion } from '@verantos-dev/core-constants';

export class AuthFetchError extends Error {
  constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly body: string
  ) {
    super(`API error: ${status} ${statusText}`);
    this.name = 'AuthFetchError';
  }
}

export async function authFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const baseUrl = `${getBaseApiUrl()}/${getGatewayApiVersion()}`;
  const token = await getToken();

  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new AuthFetchError(response.status, response.statusText, body);
  }

  // Some endpoints (e.g. DELETE → 204) return no body. Guard JSON parse so
  // callers can `await` the helper without each one wrapping in try/catch.
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json() as Promise<T>;
}
